import React, { Component } from 'react';
import axios from 'axios';
import config from './config';

class QuizResults extends Component {
    constructor(props) {
        super(props);

        this.state = {
            time: 5,
            errMsg: ''
        };

        this._redirectTimer = null;
        this.sendAPI = this.sendAPI.bind(this);
    }
    componentDidMount() {
        this.saveToAPI();
    };

    componentWillUnmount() {
        if (this._redirectTimer) {
            clearInterval(this._redirectTimer);
            this._redirectTimer = null;
        }
    }

    saveToAPI(){
        let { userId, results } = this.props;
        // Send REST API Res
        this.sendAPI({
            userId: userId,
            results: results
        });
    }

    sendAPI(data){
        let { quiz, redirect } = this.props;
    
        // Save Data
        const headers = {'Content-type': 'application/json'};

        // The quiz API fails closed: without this header it answers 403 and the
        // client's answers are never stored.
        if (config.quizSecret !== '') {
            headers['X-Quiz-Secret'] = config.quizSecret;
        }

        const instance = axios.create({
            baseURL: `${config.host}/api/`,
            timeout: 30*1000, // 30s
            headers: headers
        });

        let jsonArr = [];
        let result = {};
        let overrideResult = null;
        let weightCheck = [];
        data.results.forEach((res, idx) => {

            // Build Result Set
            try{
                if(res && res.options && res.type === 'WEIGHTED' && res.weight && res.weight.length > 0){
                    let obj = {};
                    let valIdx = res.value;
                    let w = res.weight[valIdx];
                    //res.weight.forEach((w) => {
                        res.options.forEach((opt, odx) => {
                            obj[opt] = (obj[opt] || 0) + parseInt(w[odx]);
                        });
                    //});
                    weightCheck.push(obj);
                }

                if(res && res.overrideResults){
                    if(res.type === 'SELECT'){
                        overrideResult = (res.answers && res.answers.length > 0 && res.value > -1)?res.answers[res.value]:null;
                    } else {
                        // Override RetRes
                        overrideResult = res.value;
                    }
                }

            }catch(err){}           

            let resJson = JSON.stringify(res);
            jsonArr.push({
                key: idx,
                value: resJson
            });
        });

        // Get Result
        weightCheck.forEach(resItem => {
            Object.keys(resItem).forEach(itm => {
                result[itm] = (result[itm] || 0) + resItem[itm];
            });
        });


        let postData = {
            "title": quiz.title,
            "data": jsonArr,
            "type": quiz.type || '',
            "result": (overrideResult)?JSON.stringify(overrideResult):JSON.stringify(result)
        };

        if(quiz.isCounsellor) {
            postData.counsellor_id = data.userId;
        } else {
            postData.user_id = data.userId;
        }

        console.log('[API POST DATA]', postData);
        instance.post('quiz', postData).then((ret) => {
            console.log('[API POST RET]', ret);

            if(redirect){
                let that = this;
                if (that._redirectTimer) {
                    clearInterval(that._redirectTimer);
                }
                that._redirectTimer = setInterval(() => {
                    let {time} = that.state;
                    if(time <= 0){
                        clearInterval(that._redirectTimer);
                        that._redirectTimer = null;
                        window.location.href = redirect;
                    } else {
                        that.setState({time: time-1});
                    }
                }, 1000);
            }
        }).catch(err => {
            this.setState({
                errMsg: 'Something went wrong with saving your results, please check that you are connected and try to save again.'
            });
            console.error('[API ERROR]', err);
        })     
    }

    render() {    
        let { redirect } = this.props;
        let { time, errMsg } = this.state; 
        return (
            <section className="resultsSection">
                <h2>Thank you for answering all of the questions, you will be redirected shortly</h2>
                <br/><br/>
                {(redirect)?
                <p>If the page doesn't redirect in {time} seconds, please <a className='redirectBtn' onClick={() => window.location = redirect} >Click Here</a></p>:null}
                <br/>
                <br/>
                {(errMsg.length > 0) ? 
                    <div>
                        <p style={{fontSize: '24px', color: 'red'}}>{errMsg}</p>
                        <a onClick={() => this.saveToAPI()}>Retry to Save</a>
                    </div> 
                : null}
            </section>
        );
    }
}

export default QuizResults;